//
import * as React from 'react';

import Box from '@mui/material/Box';

const StdDialogForm = (props) => {
  const { children, component = 'form', onSubmit, innerRef, sx: ferrySx, ...other } = props;

  return (
    <Box
      component={component}
      display='flex'
      flex='1'
      flexDirection='column'
      onSubmit={onSubmit}
      ref={innerRef}
      sx={{ overflowY: 'auto', ...ferrySx }}
      {...other}
    >
      {children}
    </Box>
  );
};

export default StdDialogForm;
